import {access} from 'fs';
import {canVisitCountdownPage} from '../../access';

export default {
  path: '/countdown/',
  name: 'countdown',
  meta: {
    title: 'Countdown',
    layout: 'blank',
    allowPwaReload: true,
    access: [canVisitCountdownPage],
  },
  component: () => import('./CountdownPage.vue'),
};
